<div class="dialog-container">
  <div class="dialog-header header-border">
    <div class="dialog-header-title">
      {{ 'EDIT_AMOUNT.ADD_TOPUP' | fallbackTranslate | titlecase }}
    </div>
    <div class="dialog-header-cross" (click)="cancelClicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <div class="discount-container">
    <div class="fw-600 lh-140 fs-16 clr-666 m-b-12">
      {{ 'EDIT_AMOUNT.ADD_TOPUP_AMOUNT' | fallbackTranslate }}
    </div>
    <div class="discount-card-grid">
      <div
        class="discount-card flex-center"
        *ngFor="let item of this.flatTopup"
        (click)="discountClicked(item)"
        [ngClass]="
          selectedDiscount === item?.name ? 'discount-card-selected' : null
        "
      >
        {{ item?.name }}
      </div>

      <div
        class="discount-card-input-box c-pointer"
        (click)="discountClicked({ name: 'custom_discount' })"
        [ngClass]="
          selectedDiscount === 'custom_discount'
            ? 'discount-card-selected'
            : null
        "
        nz-popover
        nzPopoverTrigger="click"
        nzPopoverPlacement="right"
        [nzPopoverContent]="virtualKeyboard"
      >
        <span class="prefix"> + {{ currency }} </span>
        <input
          tabindex="-1"
          type="text"
          #customInput
          [(ngModel)]="customDiscountValue"
          (keypress)="inputChanges($event)"
          inputmode="none"
          placeholder="{{ 'PLACEHOLDERS.ENTER_TOP_UP' | fallbackTranslate }}"
        />
      </div>
    </div>
  </div>

  <div class="discount-container">
    <div class="fw-600 lh-140 fs-16 clr-666 m-b-12">
      {{ 'EDIT_AMOUNT.SELECT_REASON' | fallbackTranslate | titlecase }}
    </div>
    <div class="discount-card-grid">
      <div
        class="discount-card flex-center"
        *ngFor="let reason of topupReasonPresets"
        (click)="reasonClicked(reason)"
        [ngClass]="
          selectedReason === reason?.label ? 'discount-card-selected' : null
        "
      >
        {{ reason?.label }}
      </div>
      <div
        class="discount-card-input-box c-pointer"
        (click)="reasonClicked({ label: 'other_reason' })"
        [ngClass]="
          selectedReason === 'other_reason' ? 'discount-card-selected' : null
        "
      >
        <input
          tabindex="-1"
          type="text"
          [(ngModel)]="customReason"
          maxlength="30"
          placeholder="{{
            'PLACEHOLDERS.ENTER_OTHER_REASONS' | fallbackTranslate
          }}"
        />
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <button class="save" (click)="submit()">
      {{ 'EDIT_AMOUNT.ADD_TOPUP' | fallbackTranslate | titlecase }}
    </button>
  </div>
</div>

<ng-template #virtualKeyboard>
  <app-virtual-keyboard
    [showTripleZeros]="true"
    (numberEntered)="getNumber($event)"
    (numBackClicked)="numBack($event)"
    (decimalClicked)="getDecimal($event)"
  ></app-virtual-keyboard>
</ng-template>
